import cheeseSpritesheet from './spritesheets/cheeseSpritesheet.png';
import cheeseSpritesheetData from './spritesheets/cheeseSpritesheet.js';

import cheetohPlayerSpritesheet from './spritesheets/cheetohPlayerSpritesheet.png';
import cheetohPlayerData from './spritesheets/cheetohPlayerData.js';
import dangerRatPlayerSpritesheet from './spritesheets/dangerRatPlayerSpritesheet.png';
import dangerRatPlayerData from './spritesheets/dangerRatPlayerData.js';
import dangerRatColonyPlayerData from './spritesheets/dangerRatColonyPlayerData.js';


import jimmyPlayerSpritesheet from './spritesheets/jimmyPlayerSpritesheet.png';
import jimmyPlayerData from './spritesheets/jimmyPlayerData.js';
import koboldPlayerSpritesheet from './spritesheets/koboldPlayerSpritesheet.png';
import koboldPlayerData from './spritesheets/koboldPlayerData.js';
import monicaPlayerSpritesheet from './spritesheets/monicaPlayerSpritesheet.png';
import monicaPlayerData from './spritesheets/monicaPlayerData.js';




import snakeyMousePlayerSpritesheet from './spritesheets/snakeyMousePlayerSpritesheet.png';
import snakeyMousePlayerData from './spritesheets/snakeyMousePlayerData.js';
import vampireMonicaPlayerSpritesheet from './spritesheets/vampireMonicaPlayerSpritesheet.png';
import vampireMonicaPlayerData from './spritesheets/vampireMonicaPlayerData.js';
import vampireMousePlayerSpritesheet from './spritesheets/vampireMousePlayerSpritesheet.png';
import vampireMousePlayerData from './spritesheets/vampireMousePlayerData.js';
import rawbRadical1Background from './backgrounds/rawbRadical1Background.jpg';
import rawbRadical2Background from './backgrounds/rawbRadical2Background.png';
import rawbRadical3Background from './backgrounds/rawbRadical3Background.png';
import tutorialImg from './backgrounds/tutorialImg.jpg';
import sprintIconSpritesheet from './spritesheets/sprintIconSpritesheet.png';
import sprintIconData from './spritesheets/sprintIconData.js';
import fullscreenIconSpritesheet from './spritesheets/fullscreenIconSpritesheet.png';
import fullscreenIconData from './spritesheets/fullscreenIconData.js';

const allAssets = {
  images: {
    cheeseSpritesheet: [cheeseSpritesheet, cheeseSpritesheetData],
    cheetohPlayerSpritesheet: [cheetohPlayerSpritesheet, cheetohPlayerData],
    dangerRatPlayerSpritesheet: [dangerRatPlayerSpritesheet, dangerRatPlayerData],
    dangerRatColonyPlayerSpritesheet: [dangerRatPlayerSpritesheet, dangerRatColonyPlayerData],
    jimmyPlayerSpritesheet: [jimmyPlayerSpritesheet, jimmyPlayerData],
    koboldPlayerSpritesheet: [koboldPlayerSpritesheet, koboldPlayerData],
    monicaPlayerSpritesheet: [monicaPlayerSpritesheet, monicaPlayerData],
    snakeyMousePlayerSpritesheet: [snakeyMousePlayerSpritesheet, snakeyMousePlayerData],
    vampireMonicaPlayerSpritesheet: [vampireMonicaPlayerSpritesheet, vampireMonicaPlayerData],
    vampireMousePlayerSpritesheet: [vampireMousePlayerSpritesheet, vampireMousePlayerData],
    sprintIconSpritesheet: [sprintIconSpritesheet, sprintIconData],
    fullscreenIconSpritesheet: [fullscreenIconSpritesheet, fullscreenIconData],
    tutorialImg: [tutorialImg, {}],
    rawbRadical1Background: [rawbRadical1Background, {}],
    rawbRadical2Background: [rawbRadical2Background, {}],
    rawbRadical3Background: [rawbRadical3Background, {}]
  }
};

export default allAssets;